import React from "react";
import { Transferforofficer13Container } from "../../../containers/SupportSystem/SupportForm/Transferforofficer13Container";

export function Transferforofficer13Page () {
    return(
        <Transferforofficer13Container/>
    )
}